import { render, staticRenderFns } from "./LogoUploader.vue?vue&type=template&id=72b9cdea&lang=pug&"
import script from "./LogoUploader.vue?vue&type=script&lang=ts&"
export * from "./LogoUploader.vue?vue&type=script&lang=ts&"
import style0 from "./LogoUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports